export const GET_SO_CART_PAGING_ENDPOINT = '/OsimCart/GetSOCartsPaging';
